import { render, staticRenderFns } from "./Ttec.vue?vue&type=template&id=5098dbb6&"
import script from "./Ttec.vue?vue&type=script&lang=js&"
export * from "./Ttec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports